import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";


@Options({
    template: false,
    el: ".js-subnav-wrap",
    ui: {
        collapseToggleLinks: "a[data-toggle='collapse']:not(.js-is-active-on-desktop)",
        accordionDrawers: ".collapse"
    }
})

export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // -------------------------------------
    // constants
    // -------------------------------------

    // * match value in `config.scss`
    static readonly BREAKPOINT_NAV_SWAP = 1200;

    // -------------------------------------
    // events
    // -------------------------------------

    // stub

    // -------------------------------------
    // functions
    // -------------------------------------

    onRender() {
        console.log("nav responsive accordion viewcontroller rendered");
        this.initWindowCheck();
        this.windowResizeCheck();
    }

    isMobileNav() {
        // need to reach out to window here.
        if ($(window).width() <= ViewController.BREAKPOINT_NAV_SWAP) {
            return true;
        } else {
            return false;
        }
    }

    windowResizeCheck() {
        // recurring check when window is resized
        $(window).resize(() => {
            this.oneTimeWindowCheck();

            if (this.isMobileNav) {
                // stub
            }
        });
    }

    initWindowCheck() {
        // initially check to see if viewport width is within mobile breakpoint.
        this.oneTimeWindowCheck();
    }

    oneTimeWindowCheck() {
        // check to see if viewport width is within mobile breakpoint.
        if (this.isMobileNav()) {
            this.activateAccordions();
            // console.log("i should use mobile nav");
        } else {
            this.deactivateAccordions();
            // console.log("i should use desktop nav");
        }
    }

    deactivateAccordions() {
        // deactivate accordion clicks
        this.ui.collapseToggleLinks.addClass("disable-clicks");
        this.ui.accordionDrawers.collapse("show");
        // console.log("trying to disable accordions");
    }

    activateAccordions() {
        // deactivate accordion clicks
        this.ui.collapseToggleLinks.removeClass("disable-clicks");
        this.ui.accordionDrawers.collapse("hide");
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/nav-responsive-accordion/controller.ts